module.exports = __webpack_public_path__ + "img/arrow-4.c3257a33.png";